import apiClient from "../helpers/apiClient";
import axios from "axios";

const api = apiClient();
const REQUEST_CACHE_TTL = 10000;
const requestCache = new Map();
const inFlightRequests = new Map();

const cachedGet = async (key, loader) => {
  const now = Date.now();
  const cached = requestCache.get(key);
  if (cached && now - cached.timestamp < REQUEST_CACHE_TTL) {
    return cached.value;
  }

  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key);
  }

  const request = loader()
    .then((value) => {
      requestCache.set(key, { value, timestamp: Date.now() });
      return value;
    })
    .finally(() => {
      inFlightRequests.delete(key);
    });

  inFlightRequests.set(key, request);
  return request;
};

export const clearTenantOwnerCache = () => {
  requestCache.clear();
  inFlightRequests.clear();
};

export const getTenantRestaurants = (tenantId) =>
  cachedGet(`tenant-restaurants:${tenantId}`, () => api.get(`/api/v2/resto/tenant/${tenantId}/all`));

export const updateTenantRestaurant = async (restoId, data, opts = {}) => {
  const response = await axios.put(`/api/v2/resto/${restoId}`, data, {
    ...opts,
    headers: {
      ...(opts.headers || {}),
    },
  });

  clearTenantOwnerCache();
  return response?.data;
};

export const getTenantRestoRanking = (tenantId) =>
  api.get(`/api/v2/resto/tenant/${tenantId}/ranking`);

export const getTenantRestoEvaluations = (tenantId) =>
  api.get(`/api/v2/resto/tenant/${tenantId}/evaluations`);

export const getRestoAdminsByOwner = (restoId) =>
  api.get(`/api/v2/resto/${restoId}/admins`);

export const deactivateTenantRestaurant = (restoId) =>
  api.post(`/api/v2/resto/${restoId}/deactivate`, {}).then((response) => {
    clearTenantOwnerCache();
    return response;
  });

export const getRestoHostsByOwner = (restoId) =>
  cachedGet(`owner-hosts:${restoId}`, () => api.get(`/api/v2/user-resto/hosts/${restoId}`));
